import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {BounceLoader} from 'react-spinners';

import styles from './Spinner.scss';
import classNames from 'classnames';

export default class Spinner extends Component {
    static propTypes = {
        className: PropTypes.string,
        hidden: PropTypes.bool,
        size: PropTypes.number,
        absolutelyCentered: PropTypes.bool,
    };

    static defaultProps = {
        size: 60,
        hidden: false,
        className: '',
        absolutelyCentered: false,
    };

    render() {
        const {hidden, className, size, absolutelyCentered} = this.props;

        const containerClassName = classNames(styles.container, className, {
            [styles.hidden]: hidden,
            [styles.absolutelyCentered]: absolutelyCentered,
        });

        return (
            <div className={containerClassName}>
                <BounceLoader color='#0096ff'
                              size={size}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/Spinner.js